import { render } from "./RegisterLayout.vue?vue&type=template&id=6e63ed86"
import script from "./RegisterLayout.vue?vue&type=script&lang=js"
export * from "./RegisterLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__